import {createInsightsMiddleware} from 'instantsearch.js/es/middlewares';
import {useLayoutEffect} from 'react';
import {useInstantSearch} from 'react-instantsearch-hooks-web';
const searchInsights = require('search-insights');
searchInsights('init', {
  appId: process.env.NEXT_PUBLIC_ALGOLIA_APPP_ID,
  apiKey: process.env.NEXT_PUBLIC_ALGOLIA_API_KEY,
  useCookie: true,
});
const InsightsMiddleware = () => {
  const {use} = useInstantSearch();

  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: searchInsights,
    });
    //@ts-ignore
    return use(middleware);
  }, [use]);

  return null;
};

export default InsightsMiddleware;
